import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Employeur } from 'src/app/shared/models/employeur';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { User } from 'src/app/shared/models/security/user';
import { saveAs } from 'file-saver';
import { PARAM_LABEL_BENEFICIAIRE } from 'src/app/core/services/constant/constants.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { Subject, debounceTime, take } from 'rxjs';
import { LogService } from 'src/app/core/services/log/log.service';
import { TypeHandicap } from 'src/app/shared/models/typeHandicap';
import { EmployeurModalAjoutFormComponent } from '../modal/prescripteur-modal-ajout-form/employeur-modal-ajout-form.component';

export type SortOrder = 'asc' | 'desc';

@Component({
	selector: 'app-list-employeur',
	templateUrl: './list-employeur.component.html',
	styleUrls: ['./list-employeur.component.scss']
})
export class ListEmployeurComponent implements OnInit {
	employeurs: Employeur[];
	currentPage = 1;

	employeurCsvFile: File = null;
	sortType = 'lastName';
	sortOrder: SortOrder = 'asc';

	nextWeekNumber: number;
	handicaps: Record<string, string>;

	listExpertise: TypeHandicap[];
	listSelectedExpertise: TypeHandicap[] = [];

	searchedInput = '';

	// nombre de page totale pour la pagination
	totalItems: number = 0;
	itemsPerPage = 10;

	user: User = null;
	isPlanif = false;
	labelEmployeurCapitalized: string;
	labelEmployeurPluralized: string;

	ajoutEmployeurModalref: BsModalRef;

	isAddable = true;
	isImportable = false;
	isExportable = false;

	isMobile = false;
	screenWidth: number;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	isAreaActive: boolean;

	isListingLoading: boolean = true;

	private searchSubject = new Subject<string>();

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {
		// ajout de délai à la saisie de recherche pour ne pas bombarder le back de requête
		this.searchSubject
			.pipe(
				debounceTime(300) // Délai en millisecondes
			)
			.subscribe(() => {
				this.searchByInput();
			});
	}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.labelEmployeurCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
		this.labelEmployeurPluralized =
			this.facade.dataStorageService.getLabelPluralized(
				PARAM_LABEL_BENEFICIAIRE
			);

		this.user = this.facade.dataStorageService.getUser();
		this.isPlanif = this.facade.dataStorageService.isPlanificatrice();

		this.getEmployeursMinimal();
	}

	getEmployeursMinimal(): void {
		this.isListingLoading = true;
		this.facade.employeurService
			.getAllEmployeurs()
			.subscribe({
				next: (employeurs: Employeur[]) => {
					this.employeurs = employeurs;
					console.log(this.employeurs);
					this.currentPage = 1;
					this.itemsPerPage = this.employeurs.length >= 5 ? 10 : 5;

					this.isListingLoading = false;
				},
				error: (err: ErrorResponse) => {
					this.logger.error(err + '');
				},
				complete: () => {
					this.isListingLoading = false;
				}
			});
	}

	selectEmployeur(employeur: Employeur): void {
		const link = ['/gestion/employeurs', employeur.id];
		this.router.navigate(link);
	}

	importEmployeurs(event: any): void {
		this.isImportable = false;
		this.employeurCsvFile = event.target.files[0];
		this.facade.employeurService
			.importEmployeurs(this.employeurCsvFile)
			.subscribe({
				next: (importStats: ImportResponse) => {
					this.facade.toastService.createSuccessToast('Import effectué');
					this.getEmployeursMinimal();
					this.isImportable = true;
				},
				error: (err: ErrorResponse) => {
					this.isImportable = true;
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				}
			});
	}

	exportEmployeurs(): void {
		this.facade.exportService
			.exportEmployeurs()
			.subscribe((blob) => saveAs(blob, 'employeur.csv'));
	}

	/**
	 * Fonction pour les paramètres de trie. Si le string choisi vaut le string courant l'on change l'ordre de trie (croissant/décroissant)
	 * sinon l'on chance la colonne de trie et l'on trie par ordre crosisant
	 * @param str colonne de trie
	 */
	sortChange(str: string): void {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	onKeyUp() {
		this.searchSubject.next(this.searchedInput);
	}


	searchByInput() {
		this.currentPage = 1;
		this.getEmployeursMinimal();
	}

	openModalAjout() {
		this.facade.authenticationService.checkIsAuthenticated();
		// const initialState = {
		// 	serviceCenter: this.user.employee.serviceCenter
		// };
		// if (this.user === null || this.user.employee.serviceCenter === null) {
		// 	this.facade.toastService.createErrorToast(
		// 		"Vous n'êtes pas rattaché à un centre."
		// 	);
		// } else {
			this.ajoutEmployeurModalref = this.modalService.show(
				EmployeurModalAjoutFormComponent,
				{
					class: 'modal-lg',
					//initialState,
					backdrop: 'static'
				}
			);
			this.ajoutEmployeurModalref.content.updateListing
				.pipe(take(1))
				.subscribe((addedEmployeur: Employeur) => {
					this.employeurs.push(addedEmployeur);
				});
		//}
	}

	pageHasChanged(pageNumber: any) {
		this.currentPage = pageNumber;

		this.getEmployeursMinimal();
	}
}
